
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../enums'
import { ExplainUtils } from '../../utils'

import { EpbButton } from '../shared/epb-button'
import TransitionSize from '../transition-size.component.vue'

export default defineComponent({
  name: 'ExplainResultsRow',
  components: {
    EpbButton,
    TransitionSize,
  },
  props: {
    resultIds: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    backgroundColor: {
      type: String as PropType<ColorEnum>,
      required: false,
      default: ColorEnum.WHITE,
    },
    level: {
      type: Number,
      default: 0,
    },
    childrenExpanded: Boolean,
  },
  data() {
    return {
      baseClass: 'epb-explain-results-row',
    }
  },
  computed: {
    rowClasses(): string[] {
      return [
        `${this.baseClass}--${this.backgroundColor}`,
        `${this.baseClass}--level-${this.level}`,
      ]
    },
  },
  methods: {
    getCellRowClasses(resultId: string): Record<string, boolean> {
      const product: Result = this.$x.results.find(({ id }: Result) => id === resultId)

      return {
        [`${this.baseClass}__cell--highlighted`]: product && ExplainUtils.isResultPinned(product),
      }
    },
  },
})
